import { object, string } from "yup";
import { STRUCTURE_TYPE } from "@user-management-context/read/domain/types/admin/teacher";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { siretValidation } from "@shared-kernel/primary/forms/validations/siret";
import { activityRegistrationNumberValidation } from "@shared-kernel/primary/forms/validations/activity-registration-number";
import { addressLookupSchema } from "@shared-kernel/primary/forms/validations/postal-address.schema";
import { EUROPEAN_COUNTRIES } from "@shared-kernel/domain/types/supported-country";
import type { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import type { AddressLookup } from "@shared-kernel/domain/types/address-lookup";

// ============================================================================
// Activity Step Schema (Step 0)
// ============================================================================

export const activityStepSchema = object({
  structureType: string().required(REQUIRED_FIELD).oneOf(Object.values(STRUCTURE_TYPE)),
  businessName: string().when("structureType", {
    is: (val: STRUCTURE_TYPE) => val === STRUCTURE_TYPE.ASSOCIATION || val === STRUCTURE_TYPE.ENTREPRISE,
    then: schema => schema.required("La raison sociale est requise").max(255),
    otherwise: schema => schema.defined(),
  }),
  siret: siretValidation(true),
  activityRegistrationNumber: activityRegistrationNumberValidation(),
  postalAddress: addressLookupSchema,
  addressComplement: string().max(255).defined(),
  country: string().required(REQUIRED_FIELD).oneOf(EUROPEAN_COUNTRIES, "Le pays doit être en Europe"),
});

export type ActivityStepInputs = {
  structureType: STRUCTURE_TYPE;
  businessName: string;
  siret: string;
  activityRegistrationNumber: string;
  postalAddress: AddressLookup;
  addressComplement: string;
  country: SUPPORTED_COUNTRY;
};
